export enum EFriendshipTab {
  Timeline = 'timeline',
  Profile = 'profile'
}
